module.exports = __webpack_public_path__ + "img/linux-stencil.2715262f.svg";